module.exports = __webpack_public_path__ + "static/media/ic_facebook.33ba5541.svg";